const events = {
  ERROR_ENCOUNTERED: "error_encountered",

  LOGIN_STARTED: "login_started",
  LOGIN_INFO_SUBMITTED: "login_info_submitted",
  LOGIN_OTP_RESENT: "login_otp_resent",
  LOGGED_IN: "logged_in",
  LOGGED_OUT: "logged_out",

  APP_BOOT_TIME: "app_boot_time",
  APP_READY_TIMEOUT_EXCEEDED: "app_ready_timeout_exceeded",

  ACCOUNT_CREATE_STARTED: "account_create_started",
  ACCOUNT_CREATE_INFO_SUBMITTED: "account_create_info_submitted",
  ACCOUNT_CREATE_INFO_CONFIRMATION_SHOWN: "account_create_conf_shown",
  ACCOUNT_CREATE_INFO_CONFIRMATION_ACCEPTED: "account_create_conf_accepted",
  ACCOUNT_CREATE_INFO_CONFIRMATION_REJECTED: "account_create_conf_rejected",
  ACCOUNT_CREATE_OTP_RESENT: "account_create_otp_resent",
  ACCOUNT_CREATED: "account_created",

  ONBOARDING_STARTED: "onboarding_started",
  ONBOARDING_STEP_CHANGED: "onboarding_step_changed",
  ONBOARDING_SKIPPED: "onboarding_skipped",
  ONBOARDING_COMPLETED: "onboarding_completed",

  BOOST_LIST_SEEN: "boost_list_seen",
  BUY_BOOST_CLICKED: "buy_boost_clicked",
  BOOST_BOUGHT: "boost_bought",
  BOOSTED_PROFILE_SEEN: "boosted_profile_seen",

  PROFILES_OPENED: "profiles_opened",
  PROFILES_EMPTY: "profiles_empty",
  PROFILES_FILTER_OPENED: "profiles_filter_opened",
  PROFILES_FILTER_UPDATED: "profiles_filter_updated",
  PROFILE_VIEWED: "profile_viewed",
  PROFILE_LIKED: "profile_liked",
  PROFILE_DISLIKED: "profile_disliked",
  PROFILE_REPORTED: "profile_reported",

  INSTA_CHAT_OPENED: "insta_chat_opened",
  INSTA_CHAT_PURCHASED: "insta_chat_purchased",

  GIFT_OPENED: "gift_opened",
  GIFT_PURCHASED: "gift_purchased",

  LIKES_OPENED: "likes_opened",
  LIKE_REVEAL_OPENED: "like_reveal_opened",
  LIKE_REVEAL_PURCHASED: "like_reveal_purchased",

  DIALOGS_OPENED: "dialogs_opened",
  DIALOG_VIEWED: "dialog_viewed",
  MESSAGE_SENT: "message_sent",
  OPEN_ENGAGEMENT_MENU: "open_engagement_menu",
  ASK_RANDOM_QUESTION: "ask_random_question",
  PLAY_GAME: "play_game",
  VIDEO_CALL_FAILED: "video_call_failed",
  VIDEO_CALL_ATTEMPTED: "video_call_attempted",
  VIDEO_CALL_JOINED: "video_call_joined",
  VIDEO_CALL_LEFT: "video_call_left",

  OWN_PROFILE_VIEWED: "own_profile_viewed",
  OWN_PROFILE_UPDATED: "own_profile_updated",
  OWN_PROFILE_VERIFICATION_OPENED: "own_profile_verification_opened",
  OWN_PROFILE_VERIFICATION_ATTEMPTED: "own_profile_verification_attempted",
  OWN_PROFILE_SETTINGS_VIEWED: "own_profile_settings_viewed",
  OWN_PROFILE_DELETED: "own_profile_deleted",

  OWN_PROFILE_COMMUNITY_OPENED: "own_profile_community_opened",
  OWN_PROFILE_COMMUNITY_JOINED: "own_profile_community_joined",
  OWN_PROFILE_COMMUNITY_EXITED: "own_profile_community_exited",

  INVITE_FRIEND_OPENED: "invite_friend_opened",
  INVITE_FRIEND_LINK_COPIED: "invite_friend_link_copied",

  TOP_UP_OPENED: "top_up_opened",
  TOP_UP_ATTEMPTED: "top_up_attempted",
  TOP_UP_FAILED: "top_up_failed",
  TOP_UP_ALTERNATE_OPENED: "top_up_alternate_opened",
  TOP_UP_ALTERNATE_ATTEMPTED: "top_up_alternate_attempted",
  TOP_UP_ALTERNATE_CANCELED: "top_up_alternate_canceled",
  TOP_UP_ALTERNATE_FAILED: "top_up_alternate_failed",

  ONLINE_PROFILES_OPENED: "online_profiles_opened",
  ONLINE_CHAT_ATTEMPTED: "online_chat_attempted",
  ONLINE_PROFILE_OPENED: "online_profile_opened",

  PULSE_OPENED: "pulse_opened",
  PULSE_POSTS_TAB_CLICKED: "pulse_posts_tab_clicked",
  PULSE_ONLINE_TAB_CLICKED: "pulse_online_tab_clicked",
  PULSE_ONLINE_PROFILE_OPENED: "pulse_online_profile_opened",
  PULSE_PROFILE_OPENED: "pulse_profile_opened",

  LOCATION_PROMPT_DISMISSED: "location_prompt_dismissed",
  LOCATION_ACCESS_REQUESTED: "location_access_requested",
  LOCATION_ACCESS_GRANTED: "location_access_granted",
  LOCATION_ACCESS_FAILED: "location_access_failed",

  MICROPHONE_ACCESS_REQUESTED: "microphone_access_requested",
  MICROPHONE_ACCESS_GRANTED: "microphone_access_granted",
  MICROPHONE_ACCESS_FAILED: "microphone_access_failed",

  PUSH_PROMPT_DISMISSED: "push_prompt_dismissed",
  PUSH_ACCESS_REQUESTED: "push_access_requested",
  PUSH_ACCESS_GRANTED: "push_access_granted",
  PUSH_ACCESS_FAILED: "push_access_failed",

  CAMERA_ACCESS_REQUESTED: "camera_access_requested",
  CAMERA_ACCESS_GRANTED: "camera_access_granted",
  CAMERA_ACCESS_FAILED: "camera_access_failed",

  UPDATE_CARD_SEEN: "update_card_seen",
  UPDATE_CARD_ANSWERED: "update_card_answered",
  UPDATE_CARD_SKIPPED: "update_card_skipped",

  SWIPE_TUTORIAL_STARTED: "swipe_tutorial_started",
  SWIPE_TUTORIAL_STEP_COMPLETED: "swipe_tutorial_step_completed",
  SWIPE_TUTORIAL_COMPLETED: "swipe_tutorial_completed",

  CONTACT_US: "contact_us",

  OPEN_NATIVE_APP_SETTINGS: "open_native_app_settings",

  CHURN_SURVEY_FALLBACK: "churn_survey_fallback",
};

const eventNames = Object.values(events);

export const isValidEvent = (event) => eventNames.indexOf(event) !== -1;

export const viewContentPageIds = {
  [events.PROFILES_OPENED]: "DiscoverPage",
  [events.LIKES_OPENED]: "WhoLikedMePage",
  [events.DIALOGS_OPENED]: "DialogListPage",
  [events.DIALOG_VIEWED]: "DialogPage",
  [events.ONLINE_PROFILES_OPENED]: "OnlineNowPage",
  [events.PROFILE_VIEWED]: "GuestProfilePage",
  [events.OWN_PROFILE_VIEWED]: "OwnProfilePage",
};

export default events;
